/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { BtnIconFilter } from "../../icons/BtnIconFilter";
import { BtnIconSettings } from "../../icons/BtnIconSettings";
import "./style.css";

export const Section = ({
  section = "section",
  className,
  icon = <BtnIconFilter className="icon-instance-node" />,
  sectionClassName,
  override = <BtnIconSettings className="icon-instance-node" />,
}) => {
  return (
    <div className={`section ${className}`}>
      {icon}
      <div className={`text-wrapper-3 ${sectionClassName}`}>{section}</div>

      {override}
    </div>
  );
};

Section.propTypes = {
  section: PropTypes.string,
};
